// material-ui
import { styled, Theme, CSSObject } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';

// project import
import { drawerWidth } from 'config';

// One curve and one clock for the whole collapse: drawer width, app bar,
// drawer header and nav items all reference these so nothing drifts out of
// sync. The standard material curve reads far smoother than `sharp`, which
// was built for elements LEAVING the screen, not resizing in place.
export const DRAWER_TRANSITION_DURATION = 280;
export const DRAWER_TRANSITION_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  borderRight: 'none',
  transition: theme.transitions.create('width', {
    easing: DRAWER_TRANSITION_EASING,
    duration: DRAWER_TRANSITION_DURATION
  }),
  overflowX: 'hidden',
  boxShadow: theme.palette.mode === 'dark' ? theme.customShadows.z1 : 'none',
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  maxHeight: '100dvh',
  '@supports not (max-height: 100dvh)': {
    maxHeight: '100vh'
  }
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: DRAWER_TRANSITION_EASING,
    duration: DRAWER_TRANSITION_DURATION
  }),
  overflowX: 'hidden',
  width: theme.spacing(7.5),
  borderRight: 'none',
  boxShadow: theme.customShadows.z1,
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  maxHeight: '100dvh',
  '@supports not (max-height: 100dvh)': {
    maxHeight: '100vh'
  }
});

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme)
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme)
  })
}));

export default MiniDrawerStyled;
